import "./index.css";
import {getImage} from "gatsby-plugin-image";
import React, {useState} from "react";
import Wrapper from "../../components/Wrapper";
import Menu from "../wma-list/menu";
import EntityKeypad from "../../components/Keypad";
import {BgImage} from "gbimage-bridge";
import {getEntityUrl} from "../../util";
import ComponentsWrapper from "../../components/ComponentsWrapper";
import {styled} from "@mui/material/styles";
import {Link} from "gatsby";
import {BaseList} from "./list";
import {NextLinks} from "../../components/NextLinks/nextLinks";

const PREFIX = 'EntityPage';

const classes = {
    root: `${PREFIX}-root`,
};

const Root = styled('div')(({ theme}
) => ({
    [`& .${classes.root}`]: {
        padding: '0',
        textDecoration: 'none',
        fontFamily: 'opensans, Verdana, Helvetica, Arial, sans-serif;',
    },
}));

const BaseHeadlineDiv = styled('h1')(({ theme }) => ({
    padding: '18px 8px',
    margin: 0,
    lineHeight: 1.15,
    fontSize: 'var(--font-size-larger)'
}));

const BaseBildbuttonLink = styled(Link)(() => ({
}));

const BaseEntityPage = (props) => {
    const { entity, config, pageContext, rootClassNames, listComponent, bildButtonLinkComponent, headlineDiv } = props;
    const { defaultLocale } = pageContext;

    const image = entity.largeImage ? getImage(entity.largeImage.localFile) : null;
    const headline = (entity.shortDesc || '').replace(/(?:\r\n|\r|\n)/g, '<br />');

    const [keypadShown, setKeypadShown] = useState(config?.showKeypadFirst || false);
    const keypadToggle = () => {
        setKeypadShown(!keypadShown);
    };

    const ListComponent = listComponent || BaseList;
    const BildButtonLinkComponent = bildButtonLinkComponent || BaseBildbuttonLink;
    const HeadlineDiv = headlineDiv || BaseHeadlineDiv;

    return <Root className={`base ${rootClassNames}`} root-id={entity.identifier}>
        <Wrapper {...props} menu={Menu} title={entity.title} keypadSwitch={config?.showKeypad || false} keypadShown={keypadShown} onKeypad={keypadToggle}>
            {keypadShown ?
                <EntityKeypad {...{ entity }} {...props} /> :

                <div className={classes.root}>
                    {image !== null &&
                        <div className="large-image">
                            <BgImage image={image} alt={headline} layout="fullWidth" style={{ width: '100%', height: '100%' }}>
                                {config.headerLink !== undefined && config.headerLink !== null &&
                                    <BildButtonLinkComponent className={` ${classes.bildbutton}`} to={getEntityUrl({ entity: config.headerLink, defaultLocale })}>
                                        {config.headerLink.title}
                                    </BildButtonLinkComponent>
                                }
                            </BgImage>
                        </div>
                    }
                    {headline?.length > 0 && <HeadlineDiv className="page-headline">{headline}</HeadlineDiv>}

                    <ComponentsWrapper {...props} defaultLocale={defaultLocale} />
                    <ListComponent {...props} />
                    <NextLinks relations={entity.Relations} originalLocale={entity.locale} defaultLocale={defaultLocale} onlyRenderIfMatchesPosition={'bottom'}/>
                </div>
            }
        </Wrapper>
    </Root>;
};

export default BaseEntityPage;
